export default __webpack_public_path__ + "static/obs-custom-dashboards-3c7fe63a2a3d744ad255f80fedcd114b.png";